import { QueryClient } from '@tanstack/react-query'

/**
 * Single QueryClient instance for the entire app.
 * Defaults here apply to every useQuery() call unless overridden.
 *
 * Tuning rationale:
 * - staleTime: 60s — treat most data as fresh for a minute. No refetch spam
 *   when components mount/unmount in quick succession.
 * - gcTime: 5m — keep cached data around for 5min after last consumer. If the
 *   user switches pillars and comes back, data is still warm.
 * - retry: 2 — auto-retry failed requests twice with exponential backoff.
 * - refetchOnWindowFocus: true — when user tabs back, refetch silently so
 *   they see fresh data. This kills a class of "data is stale" bugs.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      gcTime: 300_000,
      retry: 2,
      refetchOnWindowFocus: true,
    },
  },
})
